import UserEdit from "screens/components/UserEdit"
import { useUrl, getAdminOrgId}  from "lib/site"

function AdminUserEdit() {
    const getUrl = useUrl();
    return <UserEdit organisationId={getAdminOrgId()} returnUrl={getUrl("AdminUsers")} />

}

export default AdminUserEdit;